import { Typography } from '@analytical-alley/ui';
import React from 'react';

export const TotalContributionTooltipContent = ({
    formatNumber,
    totalContribution,
    previousTotalContribution,
}: {
    formatNumber: (val: number) => string;
    totalContribution: number;
    previousTotalContribution: number;
}) => {
    const contributionAbsDiff = totalContribution - previousTotalContribution;
    const contributionPercentageDiff =
        Math.round(
            (contributionAbsDiff / previousTotalContribution) * 100 * 100,
        ) / 100;

    return (
        <table>
            <tbody>
                <tr>
                    <td className="pr-2">
                        <Typography className="text-black dark:text-black">
                            Forecasted Total Contribution:
                        </Typography>
                    </td>
                    <td>
                        <Typography className="text-dark dark:text-dark">
                            {formatNumber(totalContribution)}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <td className="pr-2">
                        <Typography className="text-black dark:text-black">
                            Previous Total Contribution:
                        </Typography>
                    </td>
                    <td>
                        <Typography className="text-dark dark:text-dark">
                            {formatNumber(previousTotalContribution)}
                        </Typography>
                    </td>
                </tr>
                <tr>
                    <td className="pr-2">
                        <Typography className="text-black dark:text-black">
                            Change:
                        </Typography>
                    </td>
                    <td className="pr-2">
                        <Typography className="text-dark dark:text-dark">
                            {contributionPercentageDiff}% /{' '}
                            {formatNumber(contributionAbsDiff)}
                        </Typography>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};
